import styles from './NoInventory.module.css'

const NoInventory = () => {
    return (
        <div className={styles.inventorySection}>
            <h2 className={styles.inventoryTitle}>
                Инвентарь (0)
            </h2>

            <div className={styles.emptyState}>
                <div className={styles.emptyStateIcon}/>
                <p className={styles.emptyStateText}>В инвентаре еще нет ни одного подарка</p>
            </div>
        </div>
    )
}

export default NoInventory